import { FluidUom } from 'app/enums/FluidUom'
import { Fluid } from 'modules/Fluid/Fluid'
import { Model } from 'pinia-orm'

import { Attr, BelongsTo, Num, Uid } from 'pinia-orm/dist/decorators'

export class Tenant extends Model {
  static override entity = 'tenants'

  @Uid() declare id: string
  @Num(null) declare int_id: number | null

  @Attr(null) declare name: string | null
  @Attr(null) declare description: string | null
  @Attr(null) declare support_phone: string | null
  @Attr(null) declare support_url: string | null
  @Attr(null) declare support_email: string | null
  @Attr(null) declare website_url: string | null
  @Attr(null) declare store_url: string | null
  @Attr(null) declare default_fluid_id: string | null
  @Attr(null) declare default_fluid_uom: FluidUom

  @BelongsTo(() => Fluid, 'default_fluid_id') declare default_fluid: Fluid | null
}
